import React, { useEffect, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import { Table } from "../../../components/Table/Table";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const GroupAlertTypes = () => {
  const userData = JSON.parse(localStorage.getItem("user_details"));
  const loginData = JSON.parse(localStorage.getItem("loginData"));

  const [groupAlertTypesList, setGrupAlertTypesList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");

  const getList = (site_id) => {
    setSelectedSite(site_id);
    get(URL.GROUP_USERS + site_id)
      .then((res) => {
        if (res?.data?.alert_types?.length > 0) {
          setGrupAlertTypesList(res?.data?.alert_types);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (userData?.knf_type >= 4 && userData?.knf_type <= 4) {
      if (loginData?.sites?.[0]?.id) {
        let site_id_ = loginData?.sites?.[0]?.id;
        setSelectedSite(site_id_);
        getList(site_id_);
      }
      setSiteList(loginData?.sites);
    } else {
      setSelectedSite(userData?.knf_company_site_id);
      getList(userData?.knf_company_site_id);
    }
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "S.No",
      accessor: "sno",
      Cell: ({ value, row }) => {
        return <p>{row.index + 1}</p>;
      },
    },
    {
      Header: "Name",
      accessor: "alert_name",
      Cell: ({ value, row }) => {
        return <p>{value}</p>;
      },
    },
    {
      Header: "Severity",
      accessor: "alert_severity",
      Cell: ({ value, row }) => {
        return <p className="text-center">{value}</p>;
      },
    },
  ]);

  return (
    <div className="dashRightView">
      <StatusComp name={"Alert Types"} hide={true} />
      {userData?.knf_type >= 4 && userData?.knf_type <= 4 && (
        <div className="col-md-3 mb-3">
          {siteList?.length > 0 && (
            <select
              name="Site"
              value={selectedSite}
              className={`input-pop ps-2 w-100 `}
              onChange={(e) => getList(e.target.value)}
            >
              {siteList?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
          )}
        </div>
      )}
      <Table columns={columns} data={groupAlertTypesList} />
    </div>
  );
};

export default GroupAlertTypes;
